exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1dqnF{font-family:Roboto,sans-serif;font-size:18px;color:#363636;padding:50px 100px 100px}._22zCn{padding-left:15px}._1azyA{color:#e4002b;background-color:#fff;border:0;margin-top:15px;cursor:pointer;width:250px;font-size:18px;text-align:left;padding:0}._1azyA:hover{cursor:pointer;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"msg": "_1dqnF",
	"bold": "_22zCn",
	"boton_volver": "_1azyA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/MuyProntoParaIniciarConsulta/MuyProntoParaIniciarConsulta.css
// module id = 1341
// module chunks = 0 1